import { Injectable, inject } from '@angular/core';
import { ConfigService } from '../config.service';
import { AddressInfo } from '../sdk/sdk';

@Injectable({ providedIn: 'root' })
export class AddressNavigationService {
  private readonly configService = inject(ConfigService);

  openInHomepage(address: AddressInfo | undefined): void {
    const params = new URLSearchParams();
    if (address?.streetAddress) params.set('streetAddress', address.streetAddress);
    if (address?.streetAddress2) params.set('streetAddress2', address.streetAddress2);
    if (address?.city) params.set('city', address.city);
    if (address?.state) params.set('st', address.state);
    if (address?.postalCode) params.set('postalCode', address.postalCode);

    window.open(`${this.configService.homeUrl}/?${params.toString()}`, '_blank');
  }
}
